/* eslint-disable react/jsx-key */
import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
gsap.registerPlugin(ScrollTrigger)

const contentData: ContentData[][] = [
  [
    {
      type: 'sectionTitle',
      text: 'デザイン思考でのサイト分析/UI改善プロジェクト',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview1.webp',
      alt: 'インタビュー写真',
      text: '「セブンネットショッピング」のキャンペーン企画、WEB広告、SEO、UX/UI改善などを実施している村上陽祐さん（左）と壁巣翔子さん（右）',
    },
    {
      type: 'textBox',
      texts: [
        <>
          「セブンネットショッピング」のグロースプロジェクトにAitriaが携わるきっかけは、同サイトのUI改善にありました。そして、お声がけの理由には、株式会社セブン＆アイ・ホールディングスが運営するサイトに、ウェブサイトのUX/UI改善ツール
          <a href="https://gomobile.jp/flamingo/" target="_blank" rel="noopener noreferrer">
            flamingo
          </a>
          が採用されていたことにあったと言います。
        </>,
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '村上さん',
      texts: [
        'UI改善にシステム改修が伴ってしまうと、時間もお金もかかってしまい、容易にPDCAが回せなくなってしまう課題がありました。しかし、flamingoはシステム改修不要でスピーディーな改修ができる。それがAitriaさんにお願いする大きな決め手となりました。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview2.webp',
      alt: 'インタビュー写真',
      text: 'Aitria プロジェクトデザイナー武本（右）、エンジニア内山（中）、UIデザイナー吉尾（左）',
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '「セブンネットショッピング」UI改善プロセス',
    },
    {
      type: 'greyBox',
      texts: [
        <p>
          1.サイト内分析（GA、ユーザーテスト、ヒューリスティック評価など）
          <br />
          2.課題洗い出し
          <br />
          3.ボリュームが大きい画面から順に改善実施
          <br />
          4.検証
          <br />
          5.次の課題洗い出し、改善・検証ループへ
        </p>,
      ],
      color: 'white',
    },
    {
      type: 'textBox',
      texts: [
        'UI改善プロセスにおいて、村上さんと壁巣さんが印象的だったのは「デザイン思考でのサイト分析・課題抽出」だったといいます。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '壁巣さん',
      texts: [
        '当初は社内のスタッフのみで、他社ECサイトを見ながら改善点を模索していたのですが、なかなかうまく進みませんでした。そこで助けられたのが「ヒューリスティック評価」です。AitriaのUIデザイナーさんによってサイトの課題を分析いただき、自分たちでは気づけなかった細かな点もあぶり出すことができました。その分析結果に沿って実際に改善を行うと、ほんの少しの差でも一段と見やすくなったり使いやすくなったりすることが多く、勉強になりました。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        'またフラミンゴが可能にする「ABテスト」は、「セブンネットショッピング」のサイト特性上、大きな効果をもたらしました。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview3.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview4.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'greyBox',
      name: '壁巣さん',
      texts: [
        'エンタメ系ECサイトという都合上、「UI改善の効果」を確認するのが難しく、大きな悩みとなっていました。例えば、人気アイドルのリリースがあるとそれだけでセッション数もコンバージョンも跳ねてしまいますし、在庫切れがあれば離脱率が跳ね上がります。このようにGA分析での前年比が役立たなくなってしまうんです。しかし今回flamingoによって「ABテスト」を導入できたことで、UI以外を同条件とした比較ができるようになって検証がしやすくなりました。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        'こうして「セブンネットショッピング」はUI改善のPDCAを回すようになり、従来のリスティングやアフィリエイトを中心とした「サイト外からの集客」から、ユーザビリティを高めての「購入促進」へシフト。UI改善以外にも、SEOとサイト内分析もそれぞれ専門会社と連携しながら、サイト全体の最適化を図り続けています。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'textBox',
      texts: [
        'そんな新フェーズの取り組みとして実施されたのが「推し活倶楽部」における「推し色を用いたサイトカラー変更」です。',
      ],
      wide: true,
      bold: false,
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '「推し活倶楽部」の原動力は、数字ではなく「お客さまに喜んでいただきたい」という想い',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview5.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: [
        '「推し活をする人をもっと応援していきたい」という想いのもと始まった「推し活倶楽部」。その期間限定キャンペーンとしての「推し色を用いた『セブンネットショッピング』のサイトカラー変更」には、売上やアクセスといった数字ではなく「セブンネットに来たくなる理由」「他社にはないエンタメサイトとしてのUX構築」といった価値の創出が目標としてありました。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '壁巣さん',
      texts: [
        'きっかけは、SNS上で購入完了画面のスクリーンショットを使って推しグッズの購入報告を行う文化があるという情報をAitriaのプロジェクトデザイナーである武本さんから共有いただいたことになりました。UI改善を通して、2022年の目標である「サイトの基礎的な見直し」がひと段落していたので、次のステップとしてお客さまに喜んでいただける施策を行いたいと思っていたところでした。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        'そこで壁巣さんが着目したのは「推し色」。推し活をしている方の多くは、推しメンバーやキャラクターのテーマカラーである「推し色」を生活の中に取り入れているという文化を「セブンネットショッピング」にも活用できないかと考えました。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview6.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: [
        <p>
          サイトカラーの変更は
          <a href="https://7net.omni7.jp/top" target="_blank" rel="noopener noreferrer">
            こちら
          </a>
          からお試しいただけます。※スマートフォン限定
        </p>,
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'textBox',
      texts: [
        'そうして実装されたのが「推し色を用いたサイトカラー変更」。この実現に一役買ったのがまたもやflamingoでした。Aitriaのエンジニアである内山は次のように語ります。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '内山',
      texts: [
        'セブンネットショッピング様のご要望を確認して検証したところ、flamingoを使うことで実現可能だということがわかりました。しかし、各ユーザーのサイトカラーを変更するためには、その人の推し情報をどこかに持っておかなければいけません。ログイン情報に紐づいていれば簡単ですがそこの改修は簡単にできませんし、flamingoの中に持たせることも難しい。そこでちょっとした工夫を行い、端末側に情報を持たせる手法を採用して実現することができました。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        'そして推し色は全9色（現在は全10色）が用意されましたが、このセレクトにもUX/UIデザインの視点が取り入れられています。同じくAitriaのUIデザイナー吉尾はユーザビリティにこだわったと語ります。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '吉尾',
      texts: [
        'サイトのテーマカラーとして使う以上はユーザビリティの確保が大前提となります。もし色がストレスになったら離脱されてしまいますからね。背景色に使えるトーンは抑えないといけないので、背景色自体は淡めにして、注目キーワードやボタンの色で推しの色をハッキリと出すよう調整しました。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '予想外の効果、CVRが107％改善。多くの好評の声を得て継続的なサービスへ',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview7.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: [
        'こうして実装された「推し色を用いたサイトカラー変更」。その結果、直接購買に紐づかない施策であったにも関わらず、大きな効果を得ることができました。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '壁巣さん',
      texts: [
        'CVRが107％改善し、直帰率・平均セッション時間などの数値改善にも繋がっていました。これは「どうしたらお客さまに楽しんでいただけるか？喜んでいただけるか？」「どうしたら満足していただけるか？」を考えての施策に、自然と数字もついてきた結果です。このことから、お客さま目線に立って業務を行うことの大切さを実感することができました。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        'もちろん得られた結果は数字だけではありません。実際にサイトを利用しているお客さまからのポジティブな感想も多数寄せられています。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '壁巣さん',
      texts: [
        'SNSでの反応も好評で、サイトカラーを変更したスクリーンショット付きで好意的なご意見を投稿してくださったお客さまが沢山いらっしゃいました。また、アンケートでも「サイトを見る度、ワクワク感が増して、楽しかった」「推し色に変わった瞬間にキュンとなりました」などリアルに喜んでいただいている声が届いています。中でも「期間限定ではなくて、ずっと続けて欲しい」というご意見も頂けたのはとても嬉しかったです。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        'そうした好評を受けて、8月17日から新色の「レインボー」を追加した全10色展開で第2弾がスタート。さらに期間限定ではなく「セブンネットショッピング」のデフォルト機能として搭載されることになりました。',
      ],
      wide: true,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '壁巣さん',
      texts: [
        'お客さまアンケートで「箱推し（個別メンバーではなくグループ全体を推すこと）なのでレインボーにしてほしい」「推しが複数いるから何色を選択すればいいかわからない」という意見をたくさんいただいたので、レインボーを追加することにしました。これまで紫を使われている方が多かったのですが、今ではその2倍ほどのお客さまがレインボーを選択されています。今後もお客さまと一緒にサイトを作り上げていきたいです。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/sevennet/interview8.webp',
      alt: 'インタビュー写真',
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '担当者からのコメント',
    },
    {
      type: 'textBox',
      texts: [
        '「セブンネットショッピング」が競合のエンタメ系ECサイトに対して持つ強みは明確で、予約商品が店舗でいち早く手に取れるという点にあります。UI改善においては、その強みをきちんと活かせるUIを構築することを目標に取り組みました。今後は「推し色を用いたサイトカラー変更」のような施策も含め、「セブンネットショッピングで買いたい」「セブンネットショッピングを使いたい」という、顧客体験を最大化していくサイトにしたいと考えています。エンタメの世界では毎日のように新しい商品が発売されますし、お客さまの反応もどんどん変わっていきます。そうした変化をキャッチアップしながら、スピード重視かつ丁寧に今後も取り組んでいきたいと考えています。',
      ],
      wide: true,
      bold: false,
    },
  ],
]

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
